import axios from "../../utils/axiosInstance";

export const fortressAiReportListReactive = async (count, pageCount, filters, multiConditionFilters, sortModel, showAllTelemetry) => {
    const response = await axios.post("/fortressAiReportListReactive", {
        page: pageCount,
        count: count,
        filters: filters,
        multiConditionFilters: multiConditionFilters,
        sortModel: sortModel,
        showAllTelemetry: showAllTelemetry
    });
    return response.data;
};

export const findByFortressAiReportIdListReactive = async (ids) => {
    const response = await axios.post("/findByFortressAiReportIdListReactive", {
        ids: ids
    });
    return response.data;
};

export const getFortressAiReportGridFilterStateReactive = async () => {
    const response = await axios.post("/getFortressAiReportGridFilterStateReactive", {});
    return response.data;
};

export const updateFortressAiReportGridUseFilterStateReactive = async (newUseFilterState) => {
    return await axios.post("/updateFortressAiReportGridUseFilterStateReactive", {
        newUseFilterState: newUseFilterState
    });
};

export const updateFortressAiReportGridFilterModelReactive = async (newFilterModel) => {
    return await axios.post("/updateFortressAiReportGridFilterModelReactive", {
        newFilterModel: newFilterModel
    });
};

export const getFortressAiReportGridColumnStateReactive = async () => {
    const response = await axios.post("/getFortressAiReportGridColumnStateReactive", {});
    return response.data;
};

export const updateFortressAiReportGridColumnStateReactive = async (columnStatesList) => {
    return await axios.post("/updateFortressAiReportGridColumnStateReactive", {
        columnStatesList: columnStatesList
    });
};

export const updateFortressAiReportGridColumnModeReactive = async (columnMode) => {
    return await axios.post("/updateFortressAiReportGridColumnModeReactive", {
        columnMode: columnMode
    });
};

export const updateFortressAiReportGridUseColumnStateReactive = async (newUseColumnState) => {
    return await axios.post("/updateFortressAiReportGridUseColumnStateReactive", {
        newUseColumnState: newUseColumnState
    });
};

export const changeFortressAiReportNameReactive = async (newName, groupId, fortressAiReportId, endpointPathToUse = "/changeFortressAiReportNameReactive") => {
    const response = await axios.post(endpointPathToUse, {
        "newName": newName,
        "zenGroupId": groupId,
        "id": fortressAiReportId
    });
    return response;
};

// ─── Fortress AI Report Metrics (Daily) ──────────────────────────────────────

export const fortressAiReportMetrics24hrListReactive = async () => {
    const response = await axios.post("/fortressAiReportMetrics24hrListReactive", {});
    return response.data;
};

export const getFortressAiReportMetricsGridFilterStateReactive = async () => {
    const response = await axios.post("/getFortressAiReportMetricsGridFilterStateReactive", {});
    return response.data;
};

export const updateFortressAiReportMetricsGridUseFilterStateReactive = async (newUseFilterState) => {
    return await axios.post("/updateFortressAiReportMetricsGridUseFilterStateReactive", {
        newUseFilterState: newUseFilterState
    });
};

export const updateFortressAiReportMetricsGridFilterModelReactive = async (newFilterModel) => {
    return await axios.post("/updateFortressAiReportMetricsGridFilterModelReactive", {
        newFilterModel: newFilterModel
    });
};

export const getFortressAiReportMetricsGridColumnStateReactive = async () => {
    const response = await axios.post("/getFortressAiReportMetricsGridColumnStateReactive", {});
    return response.data;
};

export const updateFortressAiReportMetricsGridColumnStateReactive = async (columnStatesList) => {
    return await axios.post("/updateFortressAiReportMetricsGridColumnStateReactive", {
        columnStatesList: columnStatesList
    });
};

export const updateFortressAiReportMetricsGridColumnModeReactive = async (columnMode) => {
    return await axios.post("/updateFortressAiReportMetricsGridColumnModeReactive", {
        columnMode: columnMode
    });
};

export const updateFortressAiReportMetricsGridUseColumnStateReactive = async (newUseColumnState) => {
    return await axios.post("/updateFortressAiReportMetricsGridUseColumnStateReactive", {
        newUseColumnState: newUseColumnState
    });
};

// ─── Fortress AI Report Metrics (Hourly) ─────────────────────────────────────

export const fortressAiReportMetricsHourlyListReactive = async () => {
    const response = await axios.post("/fortressAiReportMetricsHourlyListReactive", {});
    return response.data;
};

export const updateFortressAiReportMetricsShowHourlyReactive = async (showHourly) => {
    return await axios.post("/updateFortressAiReportMetricsShowHourlyReactive", {
        visible: showHourly
    });
};

export const getFortressAiReportMetricsHourlyGridFilterStateReactive = async () => {
    const response = await axios.post("/getFortressAiReportMetricsHourlyGridFilterStateReactive", {});
    return response.data;
};

export const updateFortressAiReportMetricsHourlyGridUseFilterStateReactive = async (newUseFilterState) => {
    return await axios.post("/updateFortressAiReportMetricsHourlyGridUseFilterStateReactive", {
        newUseFilterState: newUseFilterState
    });
};

export const updateFortressAiReportMetricsHourlyGridFilterModelReactive = async (newFilterModel) => {
    return await axios.post("/updateFortressAiReportMetricsHourlyGridFilterModelReactive", {
        newFilterModel: newFilterModel
    });
};

export const getFortressAiReportMetricsHourlyGridColumnStateReactive = async () => {
    const response = await axios.post("/getFortressAiReportMetricsHourlyGridColumnStateReactive", {});
    return response.data;
};

export const updateFortressAiReportMetricsHourlyGridColumnStateReactive = async (columnStatesList) => {
    return await axios.post("/updateFortressAiReportMetricsHourlyGridColumnStateReactive", {
        columnStatesList: columnStatesList
    });
};

export const updateFortressAiReportMetricsHourlyGridColumnModeReactive = async (columnMode) => {
    return await axios.post("/updateFortressAiReportMetricsHourlyGridColumnModeReactive", {
        columnMode: columnMode
    });
};

export const updateFortressAiReportMetricsHourlyGridUseColumnStateReactive = async (newUseColumnState) => {
    return await axios.post("/updateFortressAiReportMetricsHourlyGridUseColumnStateReactive", {
        newUseColumnState: newUseColumnState
    });
};

export const updateFortressAiReportMetricsChartVisibilityReactive = async (chartVisible) => {
    return await axios.post("/updateFortressAiReportMetricsChartVisibilityReactive", {
        visible: chartVisible
    });
};